export default __webpack_public_path__ + "static/media/download.57f6a9b8.svg";